
export default {
  list: [],
  isUnique: true
}



// WEBPACK FOOTER //
// ./src/features/admin/venderFichas/store/state.js